import { FC, ChangeEvent } from 'react';

import { CreditCardPurposeFieldProps } from './CreditCardPurposeFields.types';
import { StyledCreditCardPurpose } from './CreditCardPursposeFields.styles';

export const CreditCardPurposeFields: FC<CreditCardPurposeFieldProps> = props => {
  const { business, personal, other, setPurpose, purposeBlockClassName = '', selectedPurposeCode = '' } = props;

  const handlePurposeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPurpose(event as unknown as Event, event.target.value);
  };

  return (
    <StyledCreditCardPurpose className={purposeBlockClassName}>
      <div className="option-label mr-4 pl-2 pl-md-0">
        <input
          id="personalCard"
          data-testid="personalCard"
          name="cardPurpose"
          type="radio"
          value="P"
          onClick={event => setPurpose(event as unknown as Event, 'P')}
          checked={selectedPurposeCode === 'P'}
          onChange={handlePurposeChange}
        />
        <label htmlFor="personalCard">{personal}</label>
      </div>

      <div className="option-label mr-4 pl-2 pl-md-0">
        <input
          id="businessCard"
          data-testid="businessCard"
          name="cardPurpose"
          type="radio"
          value="B"
          onClick={event => setPurpose(event as unknown as Event, 'B')}
          checked={selectedPurposeCode === 'B'}
          onChange={handlePurposeChange}
        />
        <label htmlFor="businessCard">{business}</label>
      </div>

      <div className="option-label pl-2 pl-md-0">
        <input
          id="otherCard"
          data-testid="otherCard"
          name="cardPurpose"
          type="radio"
          value="O"
          onClick={event => setPurpose(event as unknown as Event, 'O')}
          checked={selectedPurposeCode === 'O'}
          onChange={handlePurposeChange}
        />
        <label htmlFor="otherCard">{other}</label>
      </div>
    </StyledCreditCardPurpose>
  );
};
